module.exports = __webpack_public_path__ + "static/media/tbv-logo-white-no-tagline.66c9bf54.svg";